var Marionette = require('marionette'),
    $ = require('jquery'),

    fvChannel = require('glRadio').channel('FV'),
    SubApp = require('../common/SubApp'),

    ViewerSettings = require('./settings/settings'),
    ViewerState = require('./state/state'),
    ViewerChannelActions = require('./channel/channel'),

    Documents = require('./models/documents'),
    ViewModesContainer = require('../viewModes/viewModesView'),
    NotesModule = require('../notes/notes'),
    FullTextModule = require('../fulltext/module'),
    ThumbnailsView = require('../thumbnails/thumbNails'),
    IndexesModule = require('../index/indexes'),
    FindAndRedactModule = require('../findAndRedact/module'),

    ViewerLayoutView = require('./views/main/view'),
    Layout = require('../layout/layout');

require('extendJQuery');



var instVars = {

    id: null,
    channel: null, /* subApp */
    channelName: 'viewer', /* don't store on prototype -- otherwise will inc in length on each reset (eg: viewer:1:1) */

    // all above are destroyed on reset  ...
    view: null,

    state: null, // put below in state?
    activeDocIndex: 0, // default is the first requested
    activeDocument: null,
    documents: null,

    aDocReq: null, /* the user requested documents) */
    vOptions: null, /* the 'instance options' from the initial request, can be changed by reset; not those from a doc vOptions */
    settings: null, /* created from vOptions or a docVOptions -- the display of the current opts -- derived each time from vOptions or combo of those with the active document */

    validationErr: null

};


/*
* Note: with recent support for multi docs, layout really refers to 'docLayout* --
* the entire layout should be in what is now 'view'
* */

module.exports = SubApp.extend({
    /*
    * Prevent lookups from going to base prototype.
    * Add Channel Element to Prototype For SubApp Constructor.
    * fromReset implies invoked from viewer.reset (also implies fromDocChange).
    * fromDocChange: initially meant invoked from reset when active document changed in multi-doc mode,
    * now really implies called from an 'internal reset' ( eg page operations too ) ... should be named appropriately ...
    * All needs major cleanup/refactor (DVBC-1649)
    * */
    constructor: function(aDocReq, vOptions, options, id) {

        var fromReset = options && options.fromReset,
            fromDocChange = options && options.fromDocChange,
            props = _.omit( instVars, 'aDocReq' );

        /*
        * If/when have time, the below is superfluous when coming from reset,
        * where this is done in the delete ... there is a better way to accomplish this ...
        * */
        fromReset && ( props = _.omit( props, 'view', 'vOptions') );
        fromDocChange && ( props = _.omit( props, 'activeDocIndex', 'documents', 'activeDocument', 'settings', 'state' ) );

        _.extend( this, props, {id: id} );

        if ( !fromReset ) {
            this.aDocReq = aDocReq;
            this.vOptions = vOptions;
        }

        /*
        * Creation of State:
        * Must create  before channel and layout, which reference it's values.
        * Create b/f channel --> or context null --- other option wold be function but would hurt performance.
        * */
        if ( !fromDocChange ) {
            this.state = new ViewerState( {}, {
                id: this.id,
                vChannel: this.channel
            });
        }

        _.extend( this.constructor.prototype, { state: this.state }, /* need to set cxt for forwarded state fns */
            _.pick( new ViewerChannelActions( this.state), 'requests', 'commands', 'subscriptions' )
        );

        SubApp.prototype.constructor.call( this, {aInitParams: arguments}, this.id );

        _.bindAll( this, 'destroy' );
    },
    /*
    * Create empty region first to show error message && validate settings while validating necessary options.
    * Create view prior validation of settings for place to show errors if necessary.
    * Note: container never over-writable by doc option -- el only set once and always by vOptions
    * Get container for the view b/f rendering
    * ('start')
    * */
    initialize: function(aDocReq, vOptions, options) {

        /*
        * DVBC-1647, DVBC-1648: quick fix to prevent errors if vOptions is not provided on create or reset.
        * Class really needs a refactor: DVBC-1649.
        * Use this.vOptions here???
        * */
       vOptions = vOptions || {};

        var isFullScreen = !vOptions.el,
            container = isFullScreen ? $('body')[0] : vOptions.el;

        isFullScreen && _.extend( vOptions, { el: container } ) ;

        if ( !this.view ) {

            this.view = new ViewerLayoutView({
                el: container,
                vChannel: this.channel
            }).render();


        } else {

            // TODO: - is this now obsolete ???
            /* was cleared */
            this.view.resetWiring();
        }

        /* Always show while data loading after create or change/reset */
        this.channel.command('showLoading');

        var fromDocChange = options && options.fromDocChange;

        var vErr;

        /*
        * Currently only validate for the initial doc request, not if doc changes.
        * TODO: all first if multi doc -- and allow navigation to those that pass -- problem is server req is for all
        * */
        if ( !fromDocChange ) {
            vErr = this._validateDocRequest();
            if (vErr) {
                this.validationErr = vErr;
                this.triggerMethod('loadError', vErr);
                return this;
            }
        }

        /*
         * Ensure container is ignored -- always use the base.
         * Don't create settings from its el EVER -- DVBC-926.
         * Do after validation of aDocReq (it's referenced here and could be ignored ).
         * */
        var activeDocVOptions = aDocReq[this.activeDocIndex].vOptions;
        if ( activeDocVOptions )
            activeDocVOptions = _.omit( activeDocVOptions, 'el' );

        /*
        * Create settings object from this
        * Cascade of rules in overrides ...
        * Prob want to put cascade into the constructor on the settings obj ...
        * */
        var o = _.extend( {},

            vOptions, /* (base options -- all docs ) */

            /*  - prior settings if from doc change
                - have settings changed by user preferences (eg opening thumbnails, closing the notes panel) will carry over to the next document, unless
                - overwritten by activeDocVOptions, not the base options
             */

             ( fromDocChange ? this.settings.attributes : {} ),

            /* docInstance options */
             ( activeDocVOptions ?
                 _.omit( activeDocVOptions, 'openToPageNumber' ) // temp workaround: in current WF, this setting only refers to the viewer instance one, not a doc-specific one
                 : {}
             )
         );

        this.settings = new ViewerSettings(o);

        vErr = this.settings.checkOptionalParams();
        if (vErr) {
            this.validationErr = vErr;
            this.triggerMethod( 'loadError', vErr );
        }

        return this;

    },
    /**
     * TODO:
     * - all requested documents / the individual? -- currently checking all but request at 'activeDoc' level (DVBC-1706)
     * - *** really need to add an object for the doc slice *** ( do after renditions ) !!!
     *      ( this logic would be contained in there ... maybe just try with aDoqRequest )
     * - at some point this diverged from being full validation; it's now mostly looking at the container type
     * - could also loop and validate the types of all docs provided ... lot of options here
     * - this is a mess that needs refactor
     */
    _validateDocRequest: function () {

        // First generic validation that of the existence of the docRequest.
        if (!this.aDocReq)
            return 'Document Request Not Provided';


        // TODO: could be nice here and see if only one is requested, change it to an array ( like with pages, below )
        if ( !(this.aDocReq instanceof Array ) ) {
            return 'Document Request Must Be Provided as an Array.';
        }

        if ( this.aDocReq.length < 1 ) {
            return 'No Documents Requested';
        }

        /**
         * Now things get messier -- as currently we're only validating the active document ( currentDocRequest ).
         * Container: -- just check for existence and valid type: invalid values returned in the server response.
         * Note: no longer accepting 'WORKFLOW_TASK'.  People now are requesting the base filecabinet of the workflow.
         * TODO: for any of these errors, say which doc request they failed from; initially
         * ... this was only written for one document
         */
        var currentDocRequest = this.aDocReq[this.activeDocIndex];

        if ( !(currentDocRequest instanceof Object) )
            return 'Invalid Doc Request';

        var container = currentDocRequest.container;

        // container
        if (!container)
            return 'No Data Container Provided';

        if ( !(container instanceof Object) )
            return 'Invalid Container Provided';

        var containerType = container.type;

        if (!containerType)
            return 'No Container Type Provided';

        var validContainerTypes = ['FILECABINET', 'BIN'];
        if ( !( _.contains(validContainerTypes, containerType.toUpperCase())) ) {
            return 'Invalid Container Type "' + containerType + '"';
        }

        if (!container.id)
            return 'No Container ID Provided';  // message for which document ( do with DVBC-1706 )

        // Could validate numeric doc id ...

        var docId = currentDocRequest.docId; // Do we want to be case-sensitive here ... would be across the board ?

        if (!docId)
            return 'No Document ID Provided';

        // Could check if numeric ..

        // Skipping to pageIds for now ( which are optional ) ....
        var pageIds = currentDocRequest.pageIds;

        if (pageIds) {

            var arrayProvided = pageIds instanceof Array;

            // Be nice and allow to specific a non array to specify a single page id
            if ( !arrayProvided) {
                currentDocRequest['pageIds'] = [pageIds]; // (object and array are assigned by reference, so can assign to the local)
            }

            // ... could check is numeric for the items in the array, as with the other numbers
        }

    },

    /*
    * Only called from FV_enterLoggedOutMode.
    * TODO: tear down approp data on loggedOut ...
    * */
    onShowLoginView: function( unauthorizedDataModel, loginError ) {
        this.command('showLogin', unauthorizedDataModel, loginError );
    },
    /* Note: for FV level errors, validation errors, docInfo Req error */
    onLoadError: function(errMsg) {
        this.command('showLoadError', errMsg);
    },
    /*
    * Source: successful user dataFetch and reset (reset passes the options param).
    * Fetch docInfo & get necessary data from it for setting the layout (also req'd by views).
    * ( No options if from create -- would only come from reset ).
    * */
    onCreate: function(options) {

        if ( !this.documents || (options && options.refetchDocInfo) ) { // (for former could also derive from (options && options.fromDocChange) -- would be null on initial load (not reset)
            /* don't init with models, will be overwritten by fetch which will create new models */
            this.documents = new Documents();

            this.documents.fetch({
                /* fetch all -- though the active only fully 'parsed' when PARSE DATA called on the active doc */
                docReq: this.aDocReq,
                context: this,
                imageFileType: this.settings.imageFileType(),
                docModeImageWidthFn: _.bind(this.channel._requests.getDocModeImgWidth.callback, this), //Note: dynamic the width of settings.$el (max 1000)
                allowFlashNotes: fvChannel.request('allowFlashNotes'),
                includePageNotes: !this.settings.excludePageNotes()
            })
            .fail(function (jqXHR) {

                // Note: not using ajaxError command -- this assumes the main layout viewer was created and it isn't
                // TODO: unableToLoadViewerError state
                this.triggerMethod( 'loadError', $.fn.ajaxErrorMessage(jqXHR) );

            })
            .done(
                _.bind( this._postDocInfoFetch, this, options )

            );
        } else {
            this._postDocInfoFetch(options);
        }
    },
    /*
    * Set activeDocument from documents, state attributes from settings, wire communication with state, fetch activeDoc data.
    * Post docInfo fetch or onChange of document.
    * */
    _postDocInfoFetch: function( options ) {

        var state = this.state,
            s = this.settings;

        /* was using the non active doc on change b/c this.active doc returned truthy */
        var ad = this.activeDocument = this.documents.at(this.activeDocIndex);

        this.documents.invoke( 'setPropertiesPostParse', {
            /*
            * Note: this never comes from docLevel vOptions -- otherwise major issues:
            * when the settings are created, they are a mixture of the doc level and instance level ones (now with this exception).
            * Outlines need to differentiate between instance and viewer level settings --
            * it could change if from docReset -- we never want it to change in that case from what it was set to in the beginning.
            * Prob want a more clear outline on setting this stuff going forward !
            * Also note: if the # isn't within the page range, it is validated to go to the last page
            * */
            viewerLevelOpenToPageNumber: s.openToPageNumber()
        });

        /**
         * Reset rotation value of pages if document was reset or if launch from 'New Window' feature (or both).
         * ( if docInfo was re-fetched, page rotation values unsaved by the user will diverge from the db ).
         * May only want if !options.refetchDocInfo -- but doesn't hurt to do anyway.
         * Yes, very messy -- desperate need of a top-down a re-write
         */
        if ( options && options.priorDocumentCollection ) {

            // First update from all documents for document mode and thumbnails
            // Don't need to update full mode page in current workflow as it's rotation will always be set
            // ( Always it may not yet exist yet )
            this.documents.updatePageRotationsPostViewerReset( options.priorDocumentCollection );

        } else {

            var newWindowNameSpace = window[ fvChannel.request('settings').NEW_WINDOW_NAMESPACE ];

            if ( newWindowNameSpace ) {
                this.documents.updatePageRotationsPostViewerReset(  newWindowNameSpace.priorDocumentCollection );
            }

        }


        if (this.documents.length > 1)
            this.command('renderDocNav');


        /* Set state defaults dependent of the settings ( note, settings may now have been overwritten depending on user perms (above; onCreate  */
        state.set({
            viewMode: s.viewMode(),
            loadImages: !s.fullTextQuickView()
            //TODO .. fullscreen, etc, as many defaults as can here as passed from state to settings
        }, {silent: true});

        /* do post setting the above attrs from settings, which will call req -- and result in err */
        state.triggerMethod('listenToViewerChannel', this.channel);

        // When may be able to get rid of this with the additional of the full text layer
        ad.fetchData({
            fullTextQuery: this.request('fullTextQuery')
        }, this)

        .done( function() {

            /*
            * Must set current page after pageNote collections set on individual pages.
            * Dependency: page needs to be set for width calcs.
            * Also sets fullpageModel (no page change) -- need to do after page notes fetched (drawing shapes)
            * */
            if ( ad.hasPages() ) {
              
                // options.pgNumberToOpenTo refers to the number to open to after a page operation
                var pageToOpenTo = ad.getPageToOpenTo( {
                    pgNumberToOpenTo: options && options.pgNumberToOpenTo ? options.pgNumberToOpenTo : null
                });


                state.goToPage( pageToOpenTo, {initialLoad: true} );

                /*
                * Necessary b/c model broken with setting being configured after setting the settings --
                * settings would already have been merged with these
                * */
                var firstInstOpts = options && this.options['0'].vOptions;

                /* Override page mode view setting based on page type only for the first document & if not overwritten by viewer/first viewer instance settings */
                pageToOpenTo.isImageType()
                    && (options && !options.fromDocChange)
                    && (this.vOptions && !this.vOptions.pageModeScale) // ( former: this.vOptions may be undefined if called from reset ... want better handling of this.vOptions / class / workflow in general (DVBC-1649) )
                    && (firstInstOpts && !firstInstOpts.pageModeScale)
                    && s.set('pageModeScale', 'Best Fit');
            
            }

            /*
            *  Set visibility of the notes before creation of layout.
            *  Necessary for knowing the # visible notes prior to creation of the layout.
            *  (Notes can be filtered out from options prior to user interaction).
            * */
            ad.allNotes.setIsFiltered( null, {
                fromViewerLoad: true,
                hideActivityNotes: s.hideActivityNotes()
            });

            this._createLayout({
                renderSubAppsCB: _.bind(this._renderComponentModules, this),
                fromDocChange: options && options.fromDocChange,
                prDocLayoutState: options && options.prDocLayoutState, /* (always present if fromDocChange */
                prFullTextState: options && options.prFullTextState
            });

        })
        .fail(function() {
            /*
            * TODO: indicate any failure -- and if so, don't include pieces if they should be included
            * dealbreakers
            * fail to load entirely if this fails
            * */
        });
    },


    /*
    * Creation of Layout (Doc-Level) From Settings & Doc Data (and if from doc change)
    * TODO: now put as sub view in 'view  -- old layout view really refers now to 'doc layout' ...
    * */
    _createLayout: function(options) {

        var pages = this.activeDocument.pageCollection,
            cssConstants = fvChannel.request('cssConstants'),
            ad = this.activeDocument,
            documentHasPages = ad.hasPages(),
            state = this.state,
            vChannel = this.channel,
            layout = this.addSubApp('layout', {
                subAppClass: Layout,
                vChannel: vChannel
            }, this.id),

            includeDocumentMode = this.request('includeDocumentMode'),

            viewModesView = this.addSubApp('viewModes', {  // for now just a view
                subAppClass: ViewModesContainer,
                vChannel: vChannel,
                initialViewMode: this.state.viewMode(),
                documentHasNoPages: !documentHasPages
            }, this.id),

            s = this.settings,
            self = this,
            ftQuery = s.fullTextQuery();

            /*
            * Some Mediation between Layout, ModeContainer, and Viewer Model --
            * (initial render layout ensured base layout down) -- order important
            * */
            layout.request( 'renderLayout', this.view.getRegion('content'), {
                notes: ad.allNotes,
                fullTextQuery: ftQuery,
                numberFTHits: ftQuery ? ad.fullTextModel.getNumberOfHits() : 0 //TODO: derive in layout from above ...
            })
            .then( function(centerRegion) {

                /* ensure the viewModeView is down (content of the center panel */
                return $.Deferred (function($dfd) {

                    viewModesView.onShow = _.partial( $dfd.resolve, viewModesView );
                    centerRegion.show( viewModesView );

                });
            })
            .then( function() {

                if ( includeDocumentMode ) {
                    return viewModesView.request( 'renderDocContainer', pages );
                }

            })
            .then( function( docModeView ) {

                if ( !includeDocumentMode ) {
                    return;
                }

                /* Set Doc Mode Scale (in state; from settings, cssConstans, and els rendered in docMode container view */
                // Perhaps this could be made async now if always pass the el on the call to scale ... could do this via the API entry point
                var docMdScale = state.setInitialScale( 'document', s.docModeScale(), cssConstants, docModeView.getElsForScaleCalc() );

                /* Set Pg vOffsets from the docMode scale value */
                // Probably want to update vOffsets whenever scale changes -- see notes 'vOffset Refactor'
                pages.setVOffsets( docMdScale.getScaleValue() );

                /** Render the Doc Mode Pages In the Container */
                docModeView.triggerMethod('renderPages', docMdScale);

                layout.command( 'renderZoomView' , docMdScale);

                /*
                * Have state listen to scale events.
                * Note: this will cause scrolling to the current page if the page isn't the first in the document
                * */
                state.triggerMethod( 'listenToScaleEvents', docMdScale );

            })
            .then( function() {

                return viewModesView.request('initialPgModeViewRender', {
                    vChannel: vChannel,
                    model: state.fullPageModel(), /* note: not yet needed until the page view within rendered */
                    initialRender: true //(flag to not yet render image)
                });

            }).then( function( pgMdView ) {

                if ( documentHasPages ) {

                    var pgModeScale = state.setInitialScale( 'page', s.pageModeScale(), cssConstants, pgMdView.getElsForScaleCalc() );
                    pgMdView.triggerMethod('setScaleModel', pgModeScale);  // if not in this mode don't bother, div's will be visible ... though doesn't hurt
                    layout.command('renderZoomView', pgModeScale);
                    state.triggerMethod('listenToScaleEvents', pgModeScale);


                } else {
                    viewModesView.command('renderNoPagesView');
                }

                viewModesView.command( 'renderPDFMode', ad.docHasNoPDFRenderablePgs() );

                options.renderSubAppsCB( layout, options.prFullTextState );

                /*
                * 'Start' the layout -- what panels are showing --
                *  Could overlap options with render (combo in layout -- could also prevent having to reset scale on viewer )
                *  Load in document mode (eg calculations for first scale depend on panels being open / not ... (?)
                * */
                layout.command( 'setInitialLayout', {

                    fromDocChange: options.fromDocChange,
                    prDocLayoutState: options.prDocLayoutState,

                    fullTextQuery: ftQuery,
                    fullTextQuickView: s.fullTextQuickView(),

                    docHasNotes: ad.allNotes && ad.allNotes.length > 0,
                    docHasVisibleNotes: ad.allNotes && ad.allNotes.getNumberOfVisibleNotes() > 0,
                    forceOpenToNotes: s.forceOpenToNotes(),

                    autoDisplayIndexes: s.autoDisplayIndexes()

                });


                state.command('setViewerLoaded');

            });
    },
    _renderComponentModules: function(layout, prFullTextState) {

        this._createNotesModule(layout);  // Notes: always created even if no notes -- perhaps config option to exclude notes module

        var ftModel = this.activeDocument.fullTextModel;
        ftModel && this._createFullTextModule(layout, ftModel, prFullTextState);

        // if thumbs disabled and indexesIncluded -- don't even create stuff for left panel (?)

        if ( this.request('includeThumbnailsModule') ) {
            this._createThumbnails(layout, this.activeDocument.thumbCollection);
        }

        this.request('includeIndexesModule') && this._createIndexModule(layout);

        /**
         * Note: for now requires creation of Notes Module first which establishes the Creatable Note Types.
         * We could 'lift' the creatableNoteTypes to the viewer level and pass in to both the notes and
         * find and redact modules --
         * Doing so would also allow for disabling/not including the find and redact module both here and in the header.
         * But now, regardless of the perms defining the notes users can created, you will get the module, which I think makes more sense.
         */

        this.request('includeFindAndRedactModule') && this._createFindAndRedactModule(layout);

    },
    _createNotesModule: function(layout) {

        var notes = this.addSubApp('notes', {
            subAppClass: NotesModule,
            vChannel: this.channel,
            notesCollection: this.activeDocument.allNotes,
            $container: layout.request('notesEl'), //could also pass region
            hideActivityNotes: this.settings.hideActivityNotes()
        }, this.id);

        notes.triggerMethod('render');

    },
    /* last param may be undefined (only on reset/doc change) */
    _createFullTextModule: function (layout, fullTextModel, prFullTextState) {

        var ft = this.addSubApp('fullText', _.extend( {}, {
            subAppClass: FullTextModule,
            fullTextModel: fullTextModel,
            $container: layout.request('fullTextEl'),
            currentPgNumber: this.request('currentPageNumber'),
            vChannel: this.channel
        }, prFullTextState) , this.id);

        ft.command('render');
    },
    _createThumbnails: function( layout, thumbs ) {

        thumbs.setVOffsets();

        var thumbsContainer = this.addSubApp('thumbNails', {
            subAppClass: ThumbnailsView,
            collection: thumbs,
            vChannel: this.channel
        }, this.id);

        layout.request('thumbsEl').append( thumbsContainer.render().el );

        /*
         * DVBC-1245 -- quick fix to scroll to current thumb (if its not the first page).
         * Do here as the view must first be in the DOM.
         * Ideally should be called in the class/view itself.
         * Only other place I believe this is called if from goToPage.
         * For page mode, answer is onRenderPages -> scrollToCurrentPageTop ( ultimately should do the same way ... )
         * */

        var currentPg =  this.request('currentPage');
        if ( currentPg.get('number') > 1) {
            this.command( 'goToThumbnail', currentPg );
        }

    },
    _createIndexModule: function (layout) {

        this.addSubApp('indexes', {
            subAppClass: IndexesModule,
            indexes: this.activeDocument.docIndexes(),
            $container: layout.request('indexesEl'),
            vChannel: this.channel
        }, this.id);

    },


    _createFindAndRedactModule: function( layout ) {

        // May want the state module on viewer.state -- then we pass it in here
        var module = this.addSubApp('findAndRedact', {
            subAppClass: FindAndRedactModule,
            vChannel: this.channel,
            el: layout.request('findAndRedactEl'),
            creatableNoteTypesHelper: this.request('getCreatableNotesHelper'),
            userProvidedSearches: this.request('settings').findAndRedact()
        }, this.id);

        module.render();

    },

    /*
    * Distinguish from the API reset call --
    * aDocReq and vOptions remain the same; certain setting are persisted on re-load
    * */
    _internalReset: function( options ) {
        this.reset( null, null, options );
    },

    /*
    * Reset with different docRequest and optional instanceOptions.
    * If none passed -- the existing are used, which is always the case when internalOptions is defined.
    * TODO:
    *  - trigger event that makes all creation processes stop .. (or wait to created)
    *  - when get set up, call 'fromDocChange' something more descriptive (like internalReset?)
    *    ... reset with certain settings persisted
    * */
    reset: function( aDocReq, newVOptions, internalOptions ) {

        // First dissallow reset if not authenticated.
        // Besides not making sense, prevents run time errors.
        if ( !fvChannel.request('isAuthenticated'))
            return;


        // TODO: name 'fromDocChange' appropriately now that there are more sources -- eg: 'fromInternalReset'
        var DOC_CHANGE_SRCS = ['activeDocChange', 'pageDeleted', 'pageAdded', 'pageReordered'],
            fromDocChange = internalOptions && _.contains( DOC_CHANGE_SRCS, internalOptions.src );

        /* Note: el can never be overwritten for a viewer */
        var activeDoc = this.activeDocument,
            requestedDocMdsPgs = activeDoc.pageCollection.where({isLoaded: false, wasRequested: true}),
            requestedThumbs = activeDoc.thumbCollection.where({isLoaded: false, wasRequested: true}),
            fullPageModel = this.state.fullPageModel();


        /* Cancel any impending image load requests */
        if (requestedDocMdsPgs.length > 0)
            _.each(requestedDocMdsPgs, function(p) { p.trigger('page:cancelLoad'); });

        if (requestedThumbs.length > 0)
            _.each(requestedThumbs, function(p) { p.trigger('page:cancelLoad'); });

        fullPageModel && fullPageModel.trigger('page:cancelLoad'); //TODO: triggerOn


        //TODO: cancel loading of PDF in PDF mode ...
        //TODO: if note being created, warn user prior to reset

        /* Store state info prior to destruction  */

        var prDocLayoutState = !fromDocChange
                ? undefined
                : this.requestOn('layout', 'state'),
            /*  note: none of these now configurable with vOptions, just want the last ones opened into */
             prFullTextState = this.requestOn('fullText', 'getStateAttributesToPersistOnReset');

        // Used in case coming from a page action (eg delete)
        // Open to the current page # (add, delete) or if pgNumberToOpenTo provided, that #(reset)
        var pgNumberToOpenTo = internalOptions && internalOptions.pgNumberToOpenTo
            ? internalOptions.pgNumberToOpenTo
            : this.request('currentPageNumber');


        /**
         * Use to reset the rotation of any pages, which can be lost on fetch ( for users who lack permission to save rotation )
         * This is compound objects with listeners, though it shouldn't cause memory leaks since we don't store it anywhere --
         * Potential improvement is just getting the data needed from it ( mainly the documents and their pages ) -- could put a fn on the
         * object itself ( also used in open new window functionality ).
         */
        var priorDocumentCollection = this.documents;

        // Do the destroy
        // Need to reset from FV namespace, this will be gone .. (reset param or event ..)
        this.destroy( true, fromDocChange );

        /* Post - destroy */
        if (fromDocChange) {

            /*
            * aDocReq and vOptions remain the same -- they aren't destroyed
            * reset some state
            * */
            this.state.triggerMethod( 'resetFromDocChange' );

            /*
            * Set some settings to persist from the current state that may have changed since load --
            * this should have better organization
            * */
            this.settings.set({
                viewMode: this.state.viewMode()
            }, {silent: true});

            // this.activeDocument = this.documents.at(this.activeDocIndex); -- PROB WAY TO GO , BUT NOT FIXING DVBC-926
            this.activeDocument.resetLoadStateOfAllPgs();
        }
        else {
            /* from reset api call */
            this.aDocReq = aDocReq;
            this.vOptions = newVOptions;
        }

        var fromInteralPgOperation = internalOptions &&
            ( internalOptions.src === 'pageDeleted' || internalOptions.src === 'pageAdded' || internalOptions.src === 'pageReordered' );

        // if this gets large enough may want to make on class ( ... relooking at the process anyway)
        var resetWfOptions = {
            fromReset: true, //TODO: separate from fromDocChange -- just have a doc change w/out all the settings ... eg don't need to re-request the docs and settings ( ... STILL?)
            fromDocChange: fromDocChange,
            prDocLayoutState: prDocLayoutState,
            prFullTextState: prFullTextState,
            refetchDocInfo: fromInteralPgOperation,
            pgNumberToOpenTo: fromInteralPgOperation ? pgNumberToOpenTo : null,
            priorDocumentCollection: priorDocumentCollection
        };


        this.constructor.call( this, this.aDocReq, this.vOptions, resetWfOptions, this.id );
        this.triggerMethod('create', resetWfOptions);
    },

    /*
    *  fromReset implies called from viewer.reset
    *  fromDocChange means called from viewer.reset called internally when changing docs in multi-doc mode
    *  ( overriding subapp )
    *  Note: DVBC-1581 -- want to unlock the document here if a note is being edited, but that will make the
    *  calling fn's of this synchronous; an endeavor for another time
    * */
    destroy: function( fromReset, fromDocChange ) {

        SubApp.prototype.destroy.call(this);

        this.subApps = null; //TODO: leak here ...

        // If from 'reset', don't destroy the main layout view
        // eg: resetView always shown after region creation
        !fromReset && this.view.destroy();

        var staticsToDelete = _.keys( _.omit(instVars, 'id', 'channel') );

        fromReset &&
            ( staticsToDelete = _.omit(staticsToDelete, 'view') );

        fromDocChange &&
            (staticsToDelete = _.omit( fromDocChange, 'vOptions', 'activeDocIndex', 'aDocReq', 'documents', 'activeDocument', 'state', 'settings') );

        /* Note: keys will return own properties ) */
        _.each(staticsToDelete, function (p) {
            Marionette.blindTriggerOn(this[p], 'destroy');
            this[p] = null;
        }, this);

        // Only remove from the viewers array if not from reset
        !fromReset && fvChannel.command('viewerDestroyed', this);

    },


    /**
     * My 'public API'.
     * Should organize this in separate file.
     */
    requestedEl: function() {
        return this.vOptions.el;
    },
    isFullScreen: function() {
        return this.request('fullScreen');
    },
    isAttached: function() {
        var el = this.settings.el();
        if (!el)
            return false;
        return Marionette.isNodeAttached(el);
    }

});




/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/viewer/viewer.js
 ** module id = 97
 ** module chunks = 0
 **/